import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthentication } from '../contexts/AuthenticationContext';
import {Card, CardContent, CardHeader, CardTitle} from "@/components/ui/card";
import {Label} from "@/components/ui/label";
import {Input} from '@/components/ui/input';
import {Button} from "@/components/ui/button";
import {cn} from "@/lib/utils";

interface LocationState {
    from?: {
        pathname: string;
    };
}

const Login: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const { login } = useAuthentication();
    const navigate = useNavigate();
    const location = useLocation();
    const state = location.state as LocationState;

    const from = state?.from?.pathname || '/admin/dashboard';

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const success = await login(email, password);

            if (success) {
                navigate(from, { replace: true });
            } else {
                setError('Invalid email or password');
            }
        } catch (err) {
            setError('An error occurred during login');
            console.error(err);
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <div className="flex min-h-screen items-center justify-center bg-gray-50 p-4">
            <Card className="w-full max-w-md">
                <CardHeader className="space-y-1">
                    <CardTitle className="text-2xl font-bold text-center">Cloudhooks Admin</CardTitle>
                </CardHeader>
                <CardContent>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="email">Email</Label>
                            <Input
                                id="email"
                                type="email"
                                placeholder="your@email.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                className="w-full"
                            />
                        </div>
                        <div className="space-y-2">
                            <Label htmlFor="password">Password</Label>
                            <Input
                                id="password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                className="w-full"
                            />
                        </div>
                        <Button type="submit" className={cn("w-full", isLoading && "opacity-70")} disabled={isLoading}>
                            {isLoading ? "Logging in..." : "Login"}
                        </Button>

                        {error && (
                            <div className="mt-4 text-sm font-medium text-red-500 text-center" role="alert">
                                {error}
                            </div>
                        )}
                    </form>
                </CardContent>
            </Card>
        </div>
    )
};

export default Login;